/**
 * Group Block Slider
 * Initializes Slick carousel on .group-block-content elements
 * that have data-group-slider="true".
 * Each slider is independently scoped — multiple sliders work safely.
 */
(function () {
  'use strict';

  function initGroupSliders() {
    if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') return;

    var sliders = document.querySelectorAll('[data-group-slider="true"]');

    sliders.forEach(function (el, index) {
      var $el = jQuery(el);

      // Skip if already initialized
      if ($el.hasClass('slick-initialized')) return;

      // Read all settings from data attributes
      var desktopView = parseInt(el.dataset.desktopView) || 4;
      var desktopScroll = parseInt(el.dataset.desktopScroll) || 1;
      var laptopView = parseInt(el.dataset.laptopView) || 3;
      var laptopScroll = parseInt(el.dataset.laptopScroll) || 1;
      var mobileView = parseInt(el.dataset.mobileView) || 1;
      var mobileScroll = parseInt(el.dataset.mobileScroll) || 1;
      var showArrows = el.dataset.arrows === 'true';
      var showDots = el.dataset.dots === 'true';
      var autoplay = el.dataset.autoplay === 'true';
      var autoplaySpeed = parseInt(el.dataset.autoplaySpeed) || 3000;
      var loop = el.dataset.loop !== 'false'; // default true unless explicitly false
      var prevSelector = el.dataset.prevSelector || null;
      var nextSelector = el.dataset.nextSelector || null;
      var hasCustomNav = !!(prevSelector || nextSelector);
      var centerMode = el.dataset.centerMode === 'true';
      var centerPadding = el.dataset.centerPadding || '40px';
      var variableWidth = el.dataset.variableWidth === 'true';

      // Arrows: show default Slick arrows ONLY if enabled AND no custom nav
      var useDefaultArrows = showArrows && !hasCustomNav;

      // Build Slick config
      var config = {
        slidesToShow: variableWidth ? 1 : desktopView,
        slidesToScroll: desktopScroll,
        arrows: useDefaultArrows,
        dots: showDots,
        autoplay: autoplay,
        autoplaySpeed: autoplaySpeed,
        infinite: loop,
        variableWidth: variableWidth,
        centerMode: centerMode,
        centerPadding: centerMode ? centerPadding : '0px',
        speed: 500,
        cssEase: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: variableWidth ? 1 : laptopView,
              slidesToScroll: laptopScroll,
              dots: showDots,
              arrows: useDefaultArrows,
              variableWidth: variableWidth,
              centerPadding: centerMode ? centerPadding : '0px'
            }
          },
          {
            breakpoint: 750,
            settings: {
              slidesToShow: variableWidth ? 1 : mobileView,
              slidesToScroll: mobileScroll,
              dots: showDots,
              arrows: false,
              variableWidth: variableWidth,
              centerPadding: centerMode ? centerPadding : '0px'
            }
          }
        ]
      };

      // Refresh position classes on currently-active slides.
      // Adds group-slide--active-0 .. group-slide--active-N based on DOM order
      // within the active group, plus group-slide--active-center for the middle one.
      // Updates on every slide change so CSS can target "currently visible position"
      // instead of fixed data-slick-index.
      function refreshActivePositions() {
        var allSlides = el.querySelectorAll('.slick-slide');
        allSlides.forEach(function (s) {
          for (var i = s.classList.length - 1; i >= 0; i--) {
            var cls = s.classList[i];
            if (cls.indexOf('group-slide--active-') === 0) {
              s.classList.remove(cls);
            }
          }
        });
        var activeSlides = el.querySelectorAll('.slick-slide.slick-active');
        var total = activeSlides.length;
        activeSlides.forEach(function (s, i) {
          s.classList.add('group-slide--active-' + i);
          s.classList.add('group-slide--active-from-end-' + (total - 1 - i));
          if (total % 2 === 1 && i === Math.floor(total / 2)) {
            s.classList.add('group-slide--active-center');
          }
        });
        el.style.setProperty('--active-count', total);
      }

      // Hook slick events BEFORE init so init fires them
      $el.on('init.groupSlider reInit.groupSlider afterChange.groupSlider setPosition.groupSlider breakpoint.groupSlider', function () {
        refreshActivePositions();
      });

      // If using custom nav, tag the slider and inject a one-time CSS rule
      // that forcibly hides any residual Slick arrow nodes (belt-and-braces).
      if (hasCustomNav) {
        el.classList.add('group-slider--no-arrows');
        if (!window.__groupSliderArrowHideCSS) {
          window.__groupSliderArrowHideCSS = true;
          var hideStyle = document.createElement('style');
          hideStyle.textContent = '.group-slider--no-arrows .slick-prev,.group-slider--no-arrows .slick-next{display:none !important;}';
          document.head.appendChild(hideStyle);
        }
      }

      // Initialize Slick
      $el.slick(config);

      // In case init event didn't fire before our handler was bound
      refreshActivePositions();

      // Bind custom external navigation — scoped per slider instance
      if (prevSelector) {
        var $prevBtn = jQuery(prevSelector);
        if ($prevBtn.length) {
          $prevBtn.css('cursor', 'pointer');
          $prevBtn.on('click.groupSlider' + index, function (e) {
            e.preventDefault();
            $el.slick('slickPrev');
          });
        }
      }

      if (nextSelector) {
        var $nextBtn = jQuery(nextSelector);
        if ($nextBtn.length) {
          $nextBtn.css('cursor', 'pointer');
          $nextBtn.on('click.groupSlider' + index, function (e) {
            e.preventDefault();
            $el.slick('slickNext');
          });
        }
      }
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGroupSliders);
  } else {
    initGroupSliders();
  }

  // Reinitialize for Shopify Theme Editor
  document.addEventListener('shopify:section:load', function () {
    setTimeout(initGroupSliders, 200);
  });

  document.addEventListener('shopify:block:select', function () {
    setTimeout(initGroupSliders, 200);
  });

  // Destroy and reinit on section unload (prevents duplicates)
  document.addEventListener('shopify:section:unload', function (e) {
    var sliders = e.target.querySelectorAll('[data-group-slider="true"].slick-initialized');
    sliders.forEach(function (el) {
      jQuery(el).slick('unslick');
    });
  });

  window.initGroupSliders = initGroupSliders;
})();
